// extracted by mini-css-extract-plugin
export default {"features":"TariffFeatures_features__tKE7N","feature":"TariffFeatures_feature__HFZlB","featureOn":"TariffFeatures_featureOn__VVqR6","featureOff":"TariffFeatures_featureOff__FsGO5"};